import type { ExperimentClient } from '@amplitude/experiment-js-client'
import { Experiment } from '@amplitude/experiment-js-client'
import { AMPLITUDE_DEPLOYMENT_KEY } from 'core/constants/environment'
import { trackExperimentView } from '@hc-frontend/third-party-snowplow'

export interface ClientOptions {
  /** User ID from Snowplow */
  domainUserId: string
}

/** Returns a singleton instance of the Amplitude client. This can safely be called multiple times. */
export function getExperimentClient(): ExperimentClient {
  return Experiment.initialize(AMPLITUDE_DEPLOYMENT_KEY, {
    automaticExposureTracking: false,
    exposureTrackingProvider: {
      track: exposure => {
        if (!exposure.variant) {
          throw new TypeError('exposure.variant must be defined to track exposures')
        }

        trackExperimentView({
          experimentName: exposure.flag_key,
          variantName: exposure.variant,
          splitSource: 'amplitude'
        })
      }
    }
  })
}

/** Initialize the Amplitude `ExperimentClient` */
export default async function initExperimentClient({
  domainUserId
}: ClientOptions): Promise<void> {
  const experiment = getExperimentClient()
  await experiment.start({ user_id: domainUserId })
}
